import type { FC } from 'react'
import React from 'react'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { handleYoutubeLink } from '@/pages/JournalPublication/components/PublicationText/helpers'
import type { IPublicationComponentProps } from '../types'

const { media } = JOURNAL_TAG_ATTRIBUTES

export const PublicationMedia: FC<IPublicationComponentProps> = props => {
  const { attribs } = props

  if (attribs[media.main] === media.modifiers.youtube && attribs[media.url]) {
    const videoId = handleYoutubeLink(attribs[media.url])

    return (
      <iframe
        className="publicationText__media"
        src={videoId ? `https://www.youtube.com/embed/${videoId}` : attribs[media.url]}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    )
  }

  if (attribs[media.main] === media.modifiers.yaMaps)
    return <iframe src={`https://yandex.ru/map-widget/v1/?um=constructor${attribs[media.url]}`} frameBorder="0" />

  if (attribs[media.main] === media.modifiers.rutube)
    return (
      <iframe
        src={`https://rutube.ru/play/embed/${attribs[media.url]}?skinColor=7cb342`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    )

  return <></>
}
